import { alpha } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export type CustomDialogStyles =
  | "backdrop"
  | "paper"
  | "title"
  | "closeButton"
  | "closeIcon"
  | "content"
  | "actions"

type StylesProps = {
  size?: string
  withCloseIcon?: boolean
  fullScreen?: boolean
}

export const useStyles = makeStyles<StylesProps>()<CustomDialogStyles>(
  (
    { spacing, shadows },
    { size = "md", withCloseIcon = true, fullScreen = false }
  ) => ({
    backdrop: {
      backgroundColor: alpha(blueGrey[200], 0.6)
    },
    paper: {
      maxWidth: fullScreen ? "100%" : "350px",
      boxShadow: shadows[4],

      ...(!fullScreen && {
        ...(size === "sm" && { maxWidth: "500px" }),
        ...(size === "md" && { maxWidth: "700px" }),
        ...(size === "lg" && { maxWidth: "950px" }),
        ...(size === "xl" && { maxWidth: "1300px" })
      })
    },
    title: {
      display: "flex",
      alignItems: "center",
      gap: spacing(4),
      padding: spacing(3, 9, 4, 3),

      ...(!withCloseIcon && { padding: spacing(5, 5, 4, 5) })
    },
    closeButton: {
      padding: spacing(4)
    },
    closeIcon: {
      fontSize: "1.125rem"
    },
    content: {
      padding: spacing(0, 6, 5),

      ...(size === "xs" && { padding: spacing(0, 5, 5) })
    },
    actions: {
      gap: spacing(2),
      padding: spacing(4),

      "& > :not(:first-of-type)": {
        marginLeft: 0
      }
    }
  })
)
